import {CommonConstant} from '../../app/app.constants';

export enum GroupVersion {
  V1 = 1,
  V2 = 2
}
export class NewInfluencerGroup {
  public version: GroupVersion = GroupVersion.V2;
  // group id
  public id: number;
  public name: string;
  public description: string;
  // group type
  public type: number;
  public companyId: number;
  // Sources
  public sources: AutoGroupSource[] = [];
  public filters: AutoGroupFilter[] = [];
}


export class AutoGroupSource {
  public type: number;
  public sourceValues: AutoGroupSourceValue[] = [];

}

export class AutoGroupSourceValue {
  public id: number;
  public name: string;
  public type: AutoGroupSourceEnum;
}

export class AutoGroupFilter {
  public index: number;
  public type: AutoGroupFilterEnum;
  public comparison: number;
  public firstValue: number;
  public secondValue: number | string | number[];
}

export enum AutoGroupSourceEnum {
  TOPICS = 1,
  INDUSTRIES = 2,
  CAMPAIGNS = 3,
  MENTIONS = 4,
  INSTAGRAM_FOLLOWERS = 5,
  LOOKALIKE = 6,
  BRANDED_SIGNUP = 7
}

export enum AutoGroupFilterEnum {
  COUNTRY = 1,
  INFLUENCER_GENDER = 2,
  AUDIENCE_AGE = 3,
  AUDIENCE_COUNTRY = 4,
  AUDIENCE_GENDER = 5,
  AVG_REACH_PER_POST = 6,
  AVG_ENGAGEMENT_PER_POST = 7,
  AVG_INTERACTION_PER_POST = 8,
  PLATFORM = 9,
  FOLLOWERS = 10
}

export enum AutoGroupComparisonEnum {
  INCLUDE_IN = 1,
  FROM = 2,
  INCLUDE_ONLY = 3,
  ARE = 4,
  ARE_BETWEEN = 5,
  MIN = 6,
  MAX = 7,
  IS_ONE_OF = 8,
  IS_AT_LEAST = 9,
  IS_AT_MOST = 10,
  INCLUDES = 11,
  ARE_FROM = 12,
  BASE_ON = 13,
}

export const AutoGroupSourceConfig = {
  1: { id: 1, name: 'topics', comparison: [AutoGroupComparisonEnum.INCLUDE_IN] },
  2: { id: 2, name: 'industries', comparison: [AutoGroupComparisonEnum.INCLUDE_IN] },
  3: { id: 3, name: 'campaigns', comparison: [AutoGroupComparisonEnum.INCLUDE_IN] },
  4: { id: 4, name: 'mentions', comparison: [AutoGroupComparisonEnum.INCLUDE_IN] },
  5: { id: 5, name: 'instagram_followers', comparison: [AutoGroupComparisonEnum.FROM] },
  6: { id: 6, name: 'lookalike', comparison: [AutoGroupComparisonEnum.BASE_ON] },
  7: { id: 7, name: 'branded_signup', comparison: [AutoGroupComparisonEnum.FROM] }
};

export const AutoGroupFilterConfig = {
  1: { id: 1, name: 'country', comparison: [AutoGroupComparisonEnum.IS_ONE_OF], multiple: true, numOfCol: 3 },
  2: { id: 2, name: 'influencer_gender', comparison: [AutoGroupComparisonEnum.IS_ONE_OF], multiple: true, numOfCol: 3 },
  3: { id: 3, name: 'audience_age', comparison: [AutoGroupComparisonEnum.ARE_BETWEEN], multiple: false, numOfCol: 4 },
  4: { id: 4, name: 'audience_country', comparison: [AutoGroupComparisonEnum.ARE_FROM], multiple: false, numOfCol: 4 },
  5: { id: 5, name: 'audience_gender', comparison: [AutoGroupComparisonEnum.ARE], multiple: false, numOfCol: 4 },
  6: { id: 6, name: 'avg_reach_per_post', comparison: [AutoGroupComparisonEnum.IS_AT_LEAST, AutoGroupComparisonEnum.IS_AT_MOST], multiple: false, numOfCol: 3 },
  7: { id: 7, name: 'avg_engagement_per_post', comparison: [AutoGroupComparisonEnum.IS_AT_LEAST, AutoGroupComparisonEnum.IS_AT_MOST], multiple: false, numOfCol: 3 },
  8: { id: 8, name: 'avg_interaction_per_post', comparison: [AutoGroupComparisonEnum.IS_AT_LEAST, AutoGroupComparisonEnum.IS_AT_MOST], multiple: false, numOfCol: 3 },
  9: { id: 9, name: 'platform', comparison: [AutoGroupComparisonEnum.INCLUDE_ONLY], multiple: false, numOfCol: 3 },
  10: { id: 10, name: 'followers', comparison: [AutoGroupComparisonEnum.IS_AT_LEAST, AutoGroupComparisonEnum.IS_AT_MOST], multiple: false, numOfCol: 3 }
};

export const AutoGroupComparisonConfig = {
  1: { id: 1, key: 'include_in', operator: 'IN' },
  2: { id: 2, key: 'from', operator: '>=' },
  3: { id: 3, key: 'include_only', operator: '=' },
  4: { id: 4, key: 'are', operator: '>=' },
  5: { id: 5, key: 'are_between', operator: '>=' },
  6: { id: 6, key: 'min', operator: '>=' },
  7: { id: 7, key: 'max', operator: '<=' },
  8: { id: 8, key: 'is_one_of', operator: 'IN' },
  9: { id: 9, key: 'is_at_least', operator: '>=' },
  10: { id: 10, key: 'is_at_most', operator: '<=' },
  11: { id: 11, key: 'includes', operator: 'IN' },
  12: { id: 12, key: 'are_from', operator: '>=' },
  13: { id: 13, key: 'base_on', operator: '=' },
};



// WEBPACK FOOTER //
// ./src/models/auto-group/auto-group-setting.ts